import React from 'react'
// import { Typography } from '@mui/material'
import { PendingIcon } from '../svgIcons/PendingIcon'
import { AcceptIcon } from '../svgIcons/AcceotIcon'
import { OutgoingLinkIcon } from '../svgIcons/OutgoingLink'
import { decimal_int_to_float, numFormat } from '../blockchainUtils/math'
import { getToken } from '../model/tokens/helper'
import { AlertIcon } from '../svgIcons/AlertIcon'

function PendingTransaction(props: {
    network: string
    tx: { token2Amount: string; token1Amount: string; token1: any; token2: any; hash: string; type: string | string[]; status: any; error: string }
}) {
    const network = props.network

    const handleClick = () => {
        const base_url = network?.includes('mainnet') ? 'https://voyager.online' : 'https://goerli.voyager.online'
        window.open(`${base_url}/tx/${props.tx.hash}`, '_blank')
    }

    const transactionInfo = () => {
        let tx = props.tx
        const token1 = getToken(network, tx.token1)
        if (!token1 || !token1.symbol) return ''
        let symbol1 = token1.symbol

        if (props.tx.type.includes('approve')) {
            return 'Approve ' + symbol1
        }

        const token2 = getToken(network, tx.token2)
        if (!token2) return ''
        let symbol2 = token2.symbol
        let token1Amount = numFormat(decimal_int_to_float(network, tx.token1, tx.token1Amount))
        let token2Amount = numFormat(decimal_int_to_float(network, tx.token2, tx.token2Amount))

        if (props.tx.type.includes('swap')) return 'Swap ' + token1Amount + ' ' + symbol1 + ' for ' + token2Amount + ' ' + symbol2

        if (props.tx.type.includes('add_liquidity')) return 'Add Liquidity ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '

        // if (props.tx.type.includes('withdraw_liquidity')) return 'Withdraw Liquidity ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '
        if (props.tx.type.includes('withdraw_liquidity')) return 'Withdraw Liquidity ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '
        if (props.tx.type.includes('remove_liquidity')) return 'Remove Liquidity ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '

        if (props.tx.type.includes('collect')) return 'Claim fees ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '
        if (props.tx.type.includes('mint')) return 'Mint position ' + token1Amount + ' ' + symbol1 + ' and ' + token2Amount + ' ' + symbol2 + ' '
        if (props.tx.type.includes('rebalance')) return 'Rebalance position ' + symbol1 + ' / ' + token2Amount
        if (props.tx.type.includes('claim_reward')) return 'Claim STRK Reward'
    }

    function renderIcon(status: 'Pending' | 'Accepted' | 'Failed') {
        if (status === 'Pending') return <PendingIcon className='ml-2 shrink-0 w-[14px] h-[14px] text-[#FFBC6C]' />
        if (status === 'Accepted') return <AcceptIcon className='ml-2 shrink-0 w-[14px] h-[14px] text-[#68F2B0]' />
        return <AlertIcon className='ml-2 shrink-0 w-[14px] h-[14px] text-[#FF5353]' />
    }
    const txStatusAndError = (status: 'Pending' | 'Accepted' | 'Failed', error: string) => {
        let statusText = 'Failed' as 'Pending' | 'Accepted' | 'Failed'
        if (status.toLowerCase().includes('accepted')) statusText = 'Accepted'
        if (status.toLowerCase().includes('pending') || status.toLowerCase().includes('new') || status.toLowerCase().includes('received')) statusText = 'Pending'

        // if (error)
        //     return (
        //         <Typography sx={{ ml: 2 }} fontSize={16} color='#ff0000'>
        //             FAILED: {error}
        //         </Typography>
        //     )

        return (
            <span className='flex items-center font-bold font-bold justify-end flex-1'>
                {/* <div className='flex items-center w-full'> */}
                {statusText}
                {renderIcon(statusText)}
                <OutgoingLinkIcon onClick={handleClick} className='shrink-0 ml-2 cursor-pointer ml-2 w-4 h-4 text-white' />
                {/* </div> */}
            </span>
        )
    }

    return (
        <div className='lg:mt-[8px] mt-5 lg:hover:bg-[#0C3F6D] rounded-[16px] p-4'>
            <div className='flex flex-col text-[14px] lg:text-[16px] text-white'>
                <span className='flex items-center mr-4'>
                    <span className='mr-2'>{transactionInfo()}</span>
                    {/* <OutgoingLinkIcon onClick={handleClick} className='shrink-0 ml-2 cursor-pointer ml-2 w-5 h-5 text-white' /> */}
                    {txStatusAndError(props.tx.status, props.tx.error)}
                </span>
                {props.tx.error ? <span className='text-[#FF5353] text-[12px] mt-1'>{props.tx.error}</span> : null}
            </div>
        </div>
    )
}

export default PendingTransaction
